let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hYQgp")).then(() => parcelRequire('kb90x'));